module.exports = __webpack_public_path__ + "static/media/sykkelhjelm.efa067ac.mp3";